<template>
  <main class="main">
    <div class="carousel" ref="carousel" @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd">
      <div class="carousel_track-container">
        <ul class="carousel_track" ref="slider" :style="trackStyle">
          <!-- Clone of last slides for infinite scroll start -->
          <li v-for="(slide, index) in cloneSlides.beforeSlides" 
              :key="`before-${index}`"
              class="carousel_slide"
              :style="slideStyle(index)">
            <div class="carousel_image">
              <img :src="slide.url" alt="" role="presentation">
            </div>
          </li>
          
          <!-- Main slides -->
          <li v-for="(slide, index) in slides" 
              :key="`main-${index}`"
              :class="['carousel_slide', { 'is-selected': currentRealIndex === index }]"
              :style="slideStyle(index)"
              :data-position="index">
            <div class="carousel_image">
              <img :src="slide.url" alt="" role="presentation">
            </div>
          </li>

          <!-- Clone of first slides for infinite scroll end -->
          <li v-for="(slide, index) in cloneSlides.afterSlides" 
              :key="`after-${index}`"
              class="carousel_slide"
              :style="slideStyle(index)">
            <div class="carousel_image">
              <img :src="slide.url" alt="" role="presentation">
            </div>
          </li>
        </ul>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'CarouselComponent',
  props: ["slides"],
  data() {
    return {
      currentIndex: 0,
      touchStartX: 0,
      touchEndX: 0,
      slideWidth: 63, // Width for 1.5 images (100/1.5)
      isTransitioning: false
    }
  },

  computed: {
    cloneSlides() {
      return {
        beforeSlides: [this.slides[this.slides.length - 1]], // Clone last slide for start
        afterSlides: [this.slides[0]] // Clone first slide for end
      }
    },

    totalSlides() {
      return this.slides.length + this.cloneSlides.beforeSlides.length + this.cloneSlides.afterSlides.length
    },

    currentRealIndex() {
      return (this.currentIndex - this.cloneSlides.beforeSlides.length + this.slides.length) % this.slides.length
    },

    trackStyle() {
      const translateX = -(this.currentIndex * this.slideWidth);
      return {
        transform: `translateX(${translateX}%)`,
        transition: this.isTransitioning ? 'transform 0.3s ease-out' : 'none',
        
        
      }
    }
  },

  mounted() {
    this.currentIndex = this.cloneSlides.beforeSlides.length
  },

  methods: {
    slideStyle() {
      return {
        flex: `0 0 ${this.slideWidth}%`,
        position: 'relative',
      }
    },

    async prevSlide() {
      if (this.isTransitioning) return
      
      this.isTransitioning = true
      this.currentIndex--

      if (this.currentIndex < 0) {
        await this.waitForTransition()
        this.isTransitioning = false
        this.currentIndex = this.totalSlides - 2
      }

      setTimeout(() => {
        this.isTransitioning = false
      }, 300)
    },

    async nextSlide() {
      if (this.isTransitioning) return
      
      this.isTransitioning = true
      this.currentIndex++

      if (this.currentIndex >= this.totalSlides - 1) {
        await this.waitForTransition()
        this.isTransitioning = false
        this.currentIndex = 1
      }

      setTimeout(() => {
        this.isTransitioning = false
      }, 300)
    },

    waitForTransition() {
      return new Promise(resolve => {
        setTimeout(resolve, 300)
      })
    },

    handleTouchStart(event) {
      this.touchStartX = event.touches[0].clientX
    },

    handleTouchMove(event) {
      this.touchEndX = event.touches[0].clientX
    },

    handleTouchEnd() {
      const touchDiff = this.touchStartX - this.touchEndX
      const minSwipeDistance = 50

      if (Math.abs(touchDiff) > minSwipeDistance) {
        if (touchDiff > 0) {
          this.nextSlide()
        } else {
          this.prevSlide()
        }
      }
    }
  }
}
</script>

<style scoped>
.carousel {
  --color-default-state: #ddd;
  --color-active-state: #1bb9ed;
  position: relative;
  height: 65vmin;
  margin: 0 auto;
}

.carousel_track-container {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
}

.carousel_track {
  position: relative;
  display: flex;
  margin: 0;
  padding: 0;
  list-style: none;
  height: 100%;
}

.carousel_slide {
  position: relative;
  height: 100%;
  padding: 5% 12% 8%;
}

.carousel_image {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0;
  padding: 0;
}

.carousel_image > img {
  display: block;
  height: 100%;
  object-fit: cover;
  object-position: center;
  border: none;
}

.carousel_btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 10px;
  cursor: pointer;
  border: none;
  z-index: 1;
}

.jsPrev {
  left: 10px;
}

.jsNext {
  right: 10px;
}

.carousel_btn:hover {
  background-color: rgba(0, 0, 0, 0.7);
}
.is-selected{
  margin-right: 9px !important;
}
</style>